export async function openPageWithToast({ page, routeSlug, t, showToast }) {
  const realSlug = String(page?.slug || routeSlug || "").trim();
  const path = realSlug ? `/${realSlug}` : "/";

  const win = window.open(path, "_blank", "noopener,noreferrer");
  if (win) {
    showToast({
      type: "success",
      title: t("manager.toast.openedTitle", "Opened"),
      message: t("manager.toast.openedMsg", "Page opened in a new tab."),
    });
    return;
  }

  const fullUrl = `${window.location.origin}${path}`;
  try {
    await navigator.clipboard.writeText(fullUrl);
    showToast({
      type: "success",
      title: t("manager.toast.copiedTitle", "Popup blocked"),
      message: t("manager.toast.copiedMsg", "Link copied to clipboard."),
    });
  } catch {
    showToast({
      type: "error",
      title: t("manager.toast.blockedTitle", "Popup blocked"),
      message: `${t(
        "manager.toast.blockedMsg",
        "Your browser blocked opening a new tab. Copy this link:"
      )} ${fullUrl}`,
    });
  }
}